import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const VARIANTS = {
  primary:
    "bg-ws-lime text-ws-bg shadow-[0_0_0_1px_rgba(166,255,77,.6),0_10px_40px_-10px_rgba(124,255,26,.7)] hover:bg-ws-glow hover:shadow-[0_0_0_1px_rgba(166,255,77,.9),0_14px_50px_-8px_rgba(124,255,26,.9)]",
  ghost: "border border-white/15 bg-white/[0.03] text-ws-text hover:border-ws-lime/60 hover:bg-ws-lime/[0.06]",
  dark: "bg-ws-bg text-ws-text hover:bg-black",
};

export const CTAButton = ({ children, variant = "primary", href, onClick, icon = true, className = "", testid, ...rest }) => {
  const Comp = href ? motion.a : motion.button;
  const linkProps = href ? { href, target: href.startsWith("http") ? "_blank" : undefined, rel: "noopener noreferrer" } : { type: "button" };
  return (
    <Comp
      data-testid={testid}
      onClick={onClick}
      whileTap={{ scale: 0.96 }}
      className={`btn-shine group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-[background-color,box-shadow,border-color,color] duration-300 sm:text-[15px] ${VARIANTS[variant]} ${className}`}
      {...linkProps}
      {...rest}
    >
      <span className="relative z-10">{children}</span>
      {icon && (
        <ArrowUpRight
          size={18}
          className="relative z-10 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:rotate-45"
        />
      )}
    </Comp>
  );
};
